<template>
  <div>
    <div v-if="showAdminControls" class="row mt-2">
      <label class="col-sm-4 col-form-label text-capitalize-first" for="payin-balance-limit-enabled">
        {{ helper.trans('labels.payin_balance_limit_for_trader') }}
      </label>
      <div class="col-sm-8">
        <div class="form-check form-switch d-flex align-items-center">
          <input
              id="payin-balance-limit-enabled"
              class="form-check-input"
              type="checkbox"
              :disabled="!canEdit"
              v-model="settings.isPayinBalanceLimitEnabled"
          />
        </div>
      </div>
    </div>

    <template v-if="settings.isPayinBalanceLimitActive">
      <div class="row mt-2">
        <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans('labels.payin_balance_available_for_payout') }}</label>
        <div class="col-sm-8">
          <div v-if="balanceEntries.length === 0" class="text-muted small">
            {{ helper.trans('labels.payin_balance_empty') }}
          </div>
          <ul v-else class="list-unstyled mb-0">
            <li v-for="entry in balanceEntries" :key="entry.currency" class="d-flex align-items-center justify-content-between gap-2 mb-1">
              <span>
                <strong>{{ entry.currency }}:</strong>
                {{ entry.formattedAmount }}
              </span>
              <button
                  v-if="canReset"
                  type="button"
                  class="btn btn-outline-danger btn-sm text-capitalize-first flex-shrink-0"
                  @click.prevent="$emit('reset', entry.currency)"
              >
                {{ helper.trans('button.reset') }}
              </button>
            </li>
          </ul>
          <div v-if="settings.balanceResetAt" class="text-muted small mt-2">
            {{ helper.trans('labels.payin_balance_reset_at') }}: {{ formattedResetAt }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType} from 'vue'
import TraderPayoutSettingsDTO from "@/models/TraderPayoutSettingsDTO";
import {helper} from "@/service/CommonHelper";
import {dateHelper} from "@/service/DateHelper";
import {payoutSettingsBalanceEntries} from "@/service/PayoutLimitHelper";

export default defineComponent({
  props: {
    settings: {
      type: Object as PropType<TraderPayoutSettingsDTO>,
      required: true,
    },
    showAdminControls: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    canReset: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['reset'],
  setup(props) {
    const balanceEntries = computed(() => payoutSettingsBalanceEntries(
        props.settings.balanceByCurrency,
        props.settings.currencies,
    ));

    const formattedResetAt = computed(() => {
      if (!props.settings.balanceResetAt) {
        return '';
      }
      return dateHelper.format(props.settings.balanceResetAt);
    });

    return {
      helper,
      balanceEntries,
      formattedResetAt,
    };
  },
})
</script>
